/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: BrandingActions.tsx
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Action buttons component for branding tenant list.
────────────────────────────────────────────────────────────────*/

import { Edit } from 'lucide-react';
import { useI18n } from '../../../hooks/useI18n';
import SimpleTooltip from '../../../components/ui/SimpleTooltip';
import type { Tenant } from '../api/brandingApi';

interface BrandingActionsProps {
  tenant: Tenant;
  onConfigure: (tenant: Tenant) => void;
}

export function BrandingActions({ tenant, onConfigure }: BrandingActionsProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center gap-2">
      <SimpleTooltip content={t('branding.configureBranding')}>
        <button
          type="button"
          onClick={() => onConfigure(tenant)}
          className="rounded p-1 text-blue-600 transition-colors hover:bg-blue-100/50 hover:text-blue-700 dark:text-blue-400 dark:hover:bg-blue-900/30 dark:hover:text-blue-300"
          aria-label={t('branding.configureBranding')}
        >
          <Edit className="h-4 w-4" />
        </button>
      </SimpleTooltip>
    </div>
  );
}

